// extracted by mini-css-extract-plugin
export var container = "_y-0";
export var disabled = "_y-4";
export var fullWidth = "_y-3";
export var lined = "_y-1";
export var selected = "_y-5";
export var tab = "_y-2";